<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/p1WmKa/tc-custom/9780061828133.jpg?1731214479744" alt="This image is the cover for the book Covenant Rising, The Dreamtime Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Covenant Rising, The Dreamtime Series
      </h1>
      <p class="bookDescription body article font2">
        <p>In a land where magic defines the social order, the ruling tyrants alone control the most powerful sorcery ...</p><p>One of the last of a massacred race of warriors -- an unparalleled swordsman magically afflicted by spells of blind, uncontrollable rage -- Reeth Caldason wanders Bhealfa seeking vengeance ... and freedom from his strange malady. Now word has come from a sorcerer's apprentice of a mysterious Covenant in the capital city, a secretive society that may provide the escape Reeth desires. But forming an uneasy alliance with the youthful messenger could ultimately prove disastrous -- for the road they musttravel together leads into the sordid heart of a perilous conspiracy of treachery, tyranny, necromancy, and death.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Stan Nicholls
      </h2>
      
      <p class="authorDescription body article"><P>Stan Nicholls is best known for the internationally acclaimed Orcs: First Blood series. His journalism has appeared in <I>Locus, SFX,</I> the <I>Guardian</I>, the <I>Independent</I>, the <I>Daily Mirror</I>, <I>Time Out</I>, <I>Sight and Sound</I>, and <I>Rolling Stone</I>, among many other publications. He currently lives in the West Midlands, U.K., with his wife, the writer Anne Gay.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollins
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?71d702d6